import { BUTTON_VARIANTS } from 'ui/button';
import { TakeoverFooterButton } from 'ui/workflows/takeover';

type AttachTemplateTakeoverFooterProps = {
  campaignId?: number;
  showLoading: boolean;
  selectedDataFeed: number | null;
  shouldDisplayImportHTMLButton: boolean;
  onSelectTemplate: () => void;
};

export const AttachTemplateTakeoverFooter = ({
  campaignId,
  showLoading,
  selectedDataFeed,
  shouldDisplayImportHTMLButton,
  onSelectTemplate,
}: AttachTemplateTakeoverFooterProps) => {
  return (
    <>
      <TakeoverFooterButton
        variant={BUTTON_VARIANTS.PRIMARY}
        isDisabled={showLoading}
        onClick={onSelectTemplate}
      >
        {selectedDataFeed ? 'Use selected template with data feed' : 'Use selected template'}
      </TakeoverFooterButton>

      {/* Display "Import HTML" button only for email or in-app */}
      {shouldDisplayImportHTMLButton && (
        <TakeoverFooterButton
          variant={BUTTON_VARIANTS.SECONDARY}
          isDisabled={showLoading}
          onClick={() => {
            window.location.assign(`/templates/import?campaignId=${campaignId}`);
          }}
        >
          Import HTML
        </TakeoverFooterButton>
      )}
    </>
  );
};
